import simg1 from '../images/service/1.jpg'
import simg2 from '../images/service/2.jpg'
import simg3 from '../images/service/3.jpg'
import simg4 from '../images/service/4.jpg'
import simg5 from '../images/service/5.jpg'
import simg6 from '../images/service/6.jpg'
import simg7 from '../images/service/7.jpg'
import simg8 from '../images/service/8.jpg'
import simg9 from '../images/service/9.jpg'
import simg10 from '../images/service/10.jpg'
import simg11 from '../images/service/11.jpg'
import simg12 from '../images/service/12.jpg'
import simg13 from '../images/service/13.jpg'
import simg14 from '../images/service/14.jpg'
import simg15 from '../images/service/15.jpg'
import simg16 from '../images/service/16.jpg'
import simg17 from '../images/service/17.jpg'
import simg18 from '../images/service/18.jpg'
import simg19 from '../images/service/19.jpg'
import simg20 from '../images/service/20.jpg'
import simg21 from '../images/service/21.jpg'
import simg22 from '../images/service/22.jpg'
import simg23 from '../images/service/23.jpg'
import simg24 from '../images/service/24.jpg'
import simg25 from '../images/service/25.jpg'
import simg26 from '../images/service/26.jpg'
import simg27 from '../images/service/27.jpg'
import simg28 from '../images/service/28.jpg'
import simg29 from '../images/service/29.jpg'
import simg30 from '../images/service/30.jpg'
import simg31 from '../images/service/31.jpg'
import simg32 from '../images/service/32.jpg'
import simg33 from '../images/service/33.jpg'
import simg34 from '../images/service/34.jpg'
import simg35 from '../images/service/35.jpg'
import simg36 from '../images/service/36.jpg'
import simg37 from '../images/service/37.jpg'
import simg38 from '../images/service/38.jpg'
import simg39 from '../images/service/39.jpg'
import simg40 from '../images/service/40.jpg'
import simg41 from '../images/service/41.jpg'
import simg42 from '../images/service/42.jpg'
import simg43 from '../images/service/43.jpg'
import simg44 from '../images/service/44.jpg'
import simg45 from '../images/service/45.jpg'
import simg46 from '../images/service/46.jpg'
import simg47 from '../images/service/47.jpg'
import simg48 from '../images/service/48.jpg'
import simg49 from '../images/service/49.jpg'
import simg50 from '../images/service/50.jpg'



import sSimg1 from '../images/service-single/img-1.jpg'
import sSimg2 from '../images/service-single/img-2.jpg'
import sSimg3 from '../images/service-single/img-3.jpg'
import sSimg4 from '../images/service-single/img-4.jpg'
import sSimg5 from '../images/service-single/img-5.jpg'
import sSimg6 from '../images/service-single/img-6.jpg'

import icon1 from '../images/service/1.svg'
import icon2 from '../images/service/2.svg'
import icon3 from '../images/service/3.svg'
import icon4 from '../images/service/4.svg'
import icon5 from '../images/service/5.svg'
import icon6 from '../images/service/6.svg'

const Services = [
   {
      Id: '01',
      sImg: simg15,
      sSImg: sSimg1,
      icon: icon1,
      title: 'SMEs Sharia Advisory',
      slug: 'SMEs Sharia Advisory',
      description: 'MTJ Advisory provides structured Sharia advisory services tailored for SMEs to ensure business models and operations comply with Islamic principles. Our approach balances Sharia integrity with commercial practicality. We support SMEs from initial assessment to ongoing compliance and growth. The objective is sustainable, Sharia-aligned business development',
      categories: ['smes']
   },
   {
      Id: '02',
      sImg: simg16,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Business Model & Activity Assessment',
      slug: 'Business Model & Activity Assessment',
      description: 'We review core business activities, revenue streams, contracts, and operations to assess Sharia permissibility. The assessment identifies elements such as riba, gharar, or non-permissible activities. A clear Sharia position is provided along with actionable recommendations. This enables SMEs to realign their models with confidence.',
      categories: ['smes']
   },
   {
      Id: '03',
      sImg: simg17,
      sSImg: sSimg3,
      icon: icon3,
      title: 'Operational Sharia Advisory',
      slug: 'Operational Sharia Advisory',
      description: 'Continuous guidance is provided on day-to-day transactions and operational decisions. This includes sales contracts, supplier agreements, partnerships, and payment structures. Advisory is practical and business-focused to avoid disruption. SMEs receive timely responses to support informed decision-making.',
      categories: ['smes']
   },
   {
      Id: '04',
      sImg: simg4,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Compliance Gap Identification',
      slug: 'Compliance Gap Identification',
      description: 'We conduct a structured Sharia gap analysis covering contracts, policies, and workflows. Each gap is documented with its Sharia implication and risk level. Practical and commercially viable rectification measures are proposed. This ensures a smooth transition toward compliance.',
      categories: ['smes']
   },
   {
      Id: '05',
      sImg: simg19,
      sSImg: sSimg5,
      icon: icon5,
      title: 'Appointment of Sharia Board',
      slug: 'Appointment of Sharia Board',
      description: 'MTJ Advisory supports organizations in establishing strong Sharia governance through qualified Sharia Boards. We ensure appointments meet regulatory expectations and international standards. A well-structured board enhances credibility and oversight. This service strengthens stakeholder and regulator confidence.',
      categories: ['appointment']
   },
   {
      Id: '06',
      sImg: simg18,
      sSImg: sSimg6,
      icon: icon6,
      title: 'Growth-Oriented Sharia Solutions',
      slug: 'Growth-Oriented Sharia Solutions',
      description: 'As SMEs expand, we provide Sharia-compliant solutions for restructuring, financing, and new ventures. Advisory includes Islamic financing options and partnership structures. Growth strategies remain aligned with Sharia principles. This supports scalability and long-term value creation.',
      categories: ['smes']
   },
   {
      Id: '07',
      sImg: simg48,
      sSImg: sSimg1,
      icon: icon1,
      title: 'Sharia Scholar Identification',
      slug: 'Sharia-Scholar-Identification',
      description: 'We assist in identifying qualified Sharia scholars with relevant academic and industry experience. Selection considers independence, credibility, and regulatory acceptance. Appointed scholars are capable of issuing sound Sharia opinions. This ensures reliable Sharia oversight.',
      categories: ['appointment']
   },
   {
      Id: '08',
      sImg: simg2,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Board Structure & Governance',
      slug: 'Board-Structure-&-Governance',
      description: 'We help design an effective Sharia Board structure, including roles, tenure, and authority. Governance arrangements ensure independence and accountability. Structures align with international best practices. This promotes consistent application of Sharia rulings.',
      categories: ['appointment']
   },
   {
      Id: '09',
      sImg: simg3,
      sSImg: sSimg3,
      icon: icon3,
      title: 'Regulatory & Standards Compliance',
      slug: 'Regulatory-&-Standards-Compliance',
      description: 'Sharia Board appointments are aligned with AAOIFI, IFSB, and regulatory requirements. We ensure documentation, mandates, and reporting meet supervisory expectations. This reduces regulatory risk. Institutions benefit from smoother regulatory engagement.',
      categories: ['appointment']
   },
   {
      Id: '10',
      sImg: simg20,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Secretariat & Coordination Support',
      slug: 'Secretariat-&-Coordination-Support',
      description: 'We provide secretariat support including meeting coordination, agendas, and minutes. Sharia decisions are properly documented and archived. Effective coordination ensures timely reviews and approvals. This enhances communication between management and the Sharia Board.',
      categories: ['appointment']
   },
   {
      Id: '11',
      sImg: simg5,
      sSImg: sSimg5,
      icon: icon5,
      title: 'Outsourcing of Sharia Compliance Department',
      slug: 'Outsourcing-of-Sharia-Compliance-Department',
      description: 'MTJ Advisory offers a fully outsourced Sharia compliance function for cost-effective expertise. Our team acts as an extension of the organization. Continuous oversight is provided without the need for in-house resources. This model is scalable and efficient.',
      categories: ['outsourcing']
   },
   {
      Id: '12',
      sImg: simg6,
      sSImg: sSimg6,
      icon: icon6,
      title: 'Dedicated Sharia Compliance Function',
      slug: 'Dedicated-Sharia-Compliance-Function',
      description: 'We deliver ongoing Sharia oversight and advisory services. The function supports management in maintaining compliance across operations. Expert resources are available on demand. This ensures consistent Sharia monitoring.',
      categories: ['outsourcing']
   },
      {
      Id: '13',
      sImg: simg1,
      sSImg: sSimg1,
      icon: icon1,
      title: 'Policy & Procedure Development',
      slug: 'Policy-&-Procedure-Development',
      description: 'We develop Sharia compliance policies, manuals, and SOPs tailored to operations. Documents align with regulatory and Sharia standards. Regular updates reflect business or regulatory changes. This establishes a strong compliance foundation.',
      categories: ['outsourcing']
   },
    {
      Id: '14',
      sImg: simg49,
      sSImg: sSimg2,
      icon: icon2,
      title: 'Transaction & Product Oversight',
      slug: 'Transaction-&-Product-Oversight',
      description: 'Transactions and products are reviewed on a pre- and post-execution basis. Potential non-compliance is identified early. Clear corrective guidance is provided. This reduces Sharia risk.',
      categories: ['outsourcing']
   },
     {
      Id: '15',
      sImg: simg50,
      sSImg: sSimg3,
      icon: icon3,
      title: 'Reporting & Regulatory Support',
      slug: 'Reporting-&-Regulatory-Support',
      description: 'We prepare structured Sharia compliance reports for management and regulators. Reports highlight compliance status and corrective actions. Timely reporting supports inspections. This enhances governance transparency.',
      categories: ['outsourcing']
   },
    {
      Id: '16',
      sImg: simg11,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Governance Framework',
      slug: 'Sharia-Governance-Framework',
      description: 'MTJ Advisory designs robust Sharia governance frameworks tailored to organizational needs. Frameworks embed Sharia compliance across all levels. They align with regulatory expectations. Strong governance enhances accountability and transparency.',
      categories: ['framework']
   },
      {
      Id: '17',
      sImg: simg12,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Framework Design & Customization',
      slug: 'Framework-Design-&-Customization',
      description: 'We design governance frameworks based on size, complexity, and regulation. Structures define oversight and reporting mechanisms. Customization ensures practicality. This strengthens Sharia integration.',
      categories: ['framework']
   },
      {
      Id: '18',
      sImg: simg13,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Roles & Accountability Structure',
      slug: 'Roles-&-Accountability-Structure',
      description: 'Clear roles are defined for boards, management, and compliance teams. Responsibilities are aligned with best practices. This avoids overlap and gaps. Decision-making becomes more efficient.',
      categories: ['framework']
   },
      {
      Id: '19',
      sImg: simg14,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Policies, Charters & Controls',
      slug: 'Policies,-Charters-&-Controls',
      description: 'We develop Sharia policies, board charters, and internal controls. Controls prevent and detect non-compliance. Documentation supports audits and reviews. This demonstrates governance maturity.',
      categories: ['framework']
   },
      {
      Id: '20',
      sImg: simg46,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Implementation & Continuous Review',
      slug: 'Implementation-&-Continuous-Review',
      description: 'We support implementation within existing structures. Periodic reviews assess effectiveness. Improvements are recommended as businesses evolve. This ensures long-term compliance.',
      categories: ['framework']
   },
     {
      Id: '21',
      sImg: simg21,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Compliance Product Structuring',
      slug: 'Sharia-Compliance-Product-Structuring',
      description: 'MTJ Advisory supports the development of Sharia-compliant products from concept to approval. Early involvement reduces redesign risk. Products remain commercially viable. Compliance is ensured throughout the lifecycle.',
      categories: ['product']
   },
     {
      Id: '22',
      sImg: simg22,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Product Concept Evaluation',
      slug: 'Product-Concept-Evaluation',
      description: 'We assess product concepts at an early stage. Objectives, risks, and structures are reviewed. Potential Sharia issues are identified early. This saves time and cost.',
      categories: ['product']
   },
     {
      Id: '23',
      sImg: simg23,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Islamic Contract Structuring',
      slug: 'Islamic-Contract-Structuring',
      description: 'Products are structured using approved Islamic contracts. Risk-sharing and asset linkage are ensured. Structures are reviewed for practicality and compliance. This enhances market credibility.',
      categories: ['product']
   },
     {
      Id: '24',
      sImg: simg24,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Documentation & Legal Review',
      slug: 'Documentation-&-Legal-Review',
      description: 'Legal documents are reviewed for Sharia consistency. Ambiguous or non-compliant clauses are removed. Documentation supports smooth execution. Legal and Sharia risks are reduced',
      categories: ['product']
   },
     {
      Id: '25',
      sImg: simg25,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Approval Facilitation',
      slug: 'Sharia-Approval-Facilitation',
      description: 'We prepare Sharia papers and coordinate approvals. Scholar queries are addressed efficiently. Documentation is properly maintained. This enables timely product launches.',
      categories: ['product']
   },
    {
      Id: '26',
      sImg: simg47,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Review & Sharia Certification (Fatwa) Services',
      slug: 'Sharia-Review-&-Sharia-Certification-(Fatwa)-Services',
      description: 'MTJ Advisory provides independent Sharia review and certification services. Reviews ensure compliance in both form and substance. Fatwa issuance enhances credibility. Stakeholder confidence is strengthened.',
      categories: ['certification']
   },
    {
      Id: '27',
      sImg: simg7,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Comprehensive Sharia Review',
      slug: 'Comprehensive-Sharia-Review',
      description: 'We conduct detailed reviews of products, contracts, and operations. Structures and execution are assessed. Issues are clearly documented. Management gains clarity on Sharia status.',
      categories: ['certification']
   },
    {
      Id: '28',
      sImg: simg8,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Assessment Against Sharia Standards',
      slug: 'Assessment-Against-Sharia-Standards',
      description: 'Compliance is evaluated against AAOIFI and Fiqh principles. Risk allocation and profit mechanisms are reviewed. Practical execution is verified. Consistency is ensured.',
      categories: ['certification']
   },
    {
      Id: '29',
      sImg: simg9,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Fatwa Issuance & Certification',
      slug: 'Fatwa-Issuance-&-Certification',
      description: 'We facilitate formal Fatwa issuance by qualified scholars. Conditions and limitations are clearly stated. Certification supports regulatory and market acceptance. Documentation is well-structured.',
      categories: ['certification']
   },
    {
      Id: '30',
      sImg: simg10,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Stakeholder Confidence & Market Acceptance',
      slug: 'Stakeholder-Confidence-&-Market-Acceptance',
      description: 'Certified offerings build trust with customers and regulators. Transparent opinions reduce reputational risk. Sharia compliance is effectively communicated. Market positioning is strengthened.',
      categories: ['certification']
   },
     {
      Id: '31',
      sImg: simg26,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Auditing Services',
      slug: 'Sharia-Auditing-Services',
      description: 'MTJ Advisory provides independent Sharia audit services to assess compliance effectiveness. Audits are risk-based and practical. Findings support corrective action. Governance is strengthened.',
      categories: ['auditing']
   },
     {
      Id: '32',
      sImg: simg27,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Risk-Based Sharia Audit Planning',
      slug: 'Risk-Based-Sharia-Audit-Planning',
      description: 'Audit scope is designed based on Sharia risk assessment. High-risk areas receive priority. Resources are used efficiently. Proactive risk management is supported.',
      categories: ['auditing']
   },
     {
      Id: '33',
      sImg: simg28,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Execution of Sharia Audit Fieldwork',
      slug: 'Execution-of-Sharia-Audit-Fieldwork',
      description: 'We examine transactions, processes, and controls. Approved structures are tested in practice. Deviations are identified through sample testing. Compliance culture is also assessed.',
      categories: ['auditing']
   },
     {
      Id: '34',
      sImg: simg29,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Audit Findings & Recommendations',
      slug: 'Audit-Findings-&-Recommendations',
      description: 'Clear audit reports outline findings and risks. Root causes are identified. Practical recommendations are provided. Management can prioritize actions.',
      categories: ['auditing']
   },
     {
      Id: '35',
      sImg: simg30,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Follow-Up & Rectification Review',
      slug: 'Follow-Up-&-Rectification-Review',
      description: 'We review implementation of corrective measures. Effectiveness is verified. Accountability is ensured. Continuous improvement is promoted.',
      categories: ['auditing']
   },
   {
      Id: '36',
      sImg: simg31,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Zakat Calculation Services',
      slug: 'Zakat-Calculation-Services',
      description: 'MTJ Advisory provides accurate and Sharia-compliant Zakat calculation services. Calculations follow accepted Fiqh principles. Transparency is ensured. Organizations fulfill obligations with confidence.',
      categories: ['zakat']
   },
        {
      Id: '37',
      sImg: simg32,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Identification of Zakatable Assets',
      slug: 'Identification-of-Zakatable-Assets',
      description: 'We review financial statements to identify Zakatable items. Assets and liabilities are correctly classified. Sharia principles guide assessment. Accuracy is ensured.',
      categories: ['zakat']
   },
        {
      Id: '38',
      sImg: simg33,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia-Compliant Calculation Methodology',
      slug: 'Sharia-Compliant-Calculation-Methodology',
      description: 'Appropriate calculation methods are applied. Business type and valuation are considered. Calculations are consistent and transparent. Sharia alignment is maintained.',
      categories: ['zakat']
   },
        {
      Id: '39',
      sImg: simg34,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Review of Financial Data',
      slug: 'Review-of-Financial-Data',
      description: 'Financial data and assumptions are validated. Adjustments are reviewed carefully. Judgment areas are explained. Errors are minimized.',
      categories: ['zakat']
   },
        {
      Id: '40',
      sImg: simg35,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Zakat Reporting & Advisory Support',
      slug: 'Zakat-Reporting-&-Advisory-Support',
      description: 'Detailed Zakat reports are provided. Guidance on payment and disclosure is offered. Transparency is enhanced. Religious obligations are properly fulfilled.',
      categories: ['zakat']
   },
        {
      Id: '41',
      sImg: simg36,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Screening Services',
      slug: 'Sharia-Screening-Services',
      description: 'MTJ Advisory provides Sharia screening for investment and compliance purposes. Screening assesses both activities and financial ratios. Ongoing monitoring is available. Transparency is ensured.',
      categories: ['screening']
   },
        {
      Id: '42',
      sImg: simg37,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Business Activity Screening',
      slug: 'Business-Activity-Screening',
      description: 'Core activities are reviewed for permissibility. Prohibited sectors are identified. A clear Sharia position is issued. Eligibility is confirmed.',
      categories: ['screening']
   },
        {
      Id: '43',
      sImg: simg38,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Financial Ratio Screening',
      slug: 'Financial-Ratio-Screening',
      description: 'Key financial ratios are assessed against Sharia benchmarks. Reliable data is used. Quantitative compliance is evaluated. Investment decisions are supported.',
      categories: ['screening']
   },
        {
      Id: '44',
      sImg: simg39,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Ongoing Monitoring',
      slug: 'Ongoing-Monitoring',
      description: 'Continuous monitoring tracks changes over time. Compliance status is updated regularly. Breaches are identified early. Timely action is enabled.',
      categories: ['screening']
   },
        {
      Id: '45',
      sImg: simg40,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Screening Reports & Certification',
      slug: 'Screening-Reports-&-Certification',
      description: 'Formal screening reports are issued. Findings and methodology are clearly presented. Certification can be facilitated. Credibility is enhanced.',
      categories: ['screening']
   },
         {
      Id: '46',
      sImg: simg41,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Sharia Training',
      slug: 'Sharia-Training',
      description: 'MTJ Advisory delivers structured Sharia training programs for boards, management, and staff. Training is practical and industry-specific. Awareness and capability are enhanced. Compliance culture is strengthened.',
      categories: ['training']
   },
         {
      Id: '47',
      sImg: simg42,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Customized Training Design',
      slug: 'Customized-Training-Design',
      description: 'Programs are tailored to organizational needs. Industry and regulatory context is considered. Content is relevant and practical. Learning impact is maximized.',
      categories: ['training']
   },
         {
      Id: '48',
      sImg: simg43,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Practical Application of Sharia Training',
      slug: 'Practical-Application-of-Sharia-Training',
      description: 'Training focuses on real-world scenarios and case studies. Participants understand operational impact. Decision-making improves. Compliance becomes proactive.',
      categories: ['training']
   },
         {
      Id: '49',
      sImg: simg44,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Standards & Regulatory Coverage',
      slug: 'Standards-&-Regulatory-Coverage',
      description: 'AAOIFI and regulatory standards are covered. Governance expectations are explained. Responsibilities are clarified. Regulatory interaction improves.',
      categories: ['training']
   },
         {
      Id: '50',
      sImg: simg45,
      sSImg: sSimg4,
      icon: icon4,
      title: 'Workshops & Continuous Learning',
      slug: 'Workshops-&-Continuous-Learning',
      description: 'Training is delivered through workshops and seminars. Virtual options are available. Ongoing learning keeps teams updated. Institutional capability is strengthened.',
      categories: ['training']
   },
   
]

export default Services;